export function humanize(text: string | null | undefined, preserveCasing: boolean = true) {
  if (text == null) {
    return '';
  }

  let val = text;
  const hasSnakes = /_/.test(text);
  if (!hasSnakes && text.toUpperCase() === text) {
    return text;
  }
  if (hasSnakes) {
    val = text.replace(/_/g, ' ');
  } else {
    val = text.replace(/([A-Z])/g, ' $1').replace(/^ /, '');
  }
  if (!preserveCasing) {
    return val
      .replace(/[A-Z]/g, (v) => v.toLowerCase())
      .replace(/^./, (s) => {
        return s.toUpperCase();
      });
  } else {
    return val;
  }
}

export function hyphenate(text: string) {
  return text.replace(/([A-Z])/g, '-$1').replace(/^-/, '');
}
